import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../../Service/axiosInstance";
import { Button } from '@mui/material';

const Login = ({ setUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idPackage = queryParams.get('idPackage');

  const handleLogin = async (e) => {
    e.preventDefault();

    const userCredentials = {
      mail: email,
      motdepasse: password,
    };

    try {
      const response = await axiosInstance.post("/yourtravelshop/login", userCredentials);

      if (response.data.message === "Connexion réussie" && response.data.user) {
        const token = response.data.token;
        const user = response.data.user;

        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        setUser(user); 
        setMessage("Connexion réussie!");

        if (idPackage) {
          navigate(`/Package-details/${idPackage}`, { replace: true });
        } else {
          navigate("/Home");
        }

      } else {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setMessage(response.data.message || "Erreur lors de la connexion.");
      }
    } catch (error) {
      setMessage("Erreur lors de la connexion.");
    }
  };

  return (
    <div className="containerLogin">
      <br /><br />
      <div className="row d-flex justify-content-center mt-5">
        <div className="col-12 col-md-8 col-lg-6 col-xl-5">
          <div className="card py-3 px-2">
            <form onSubmit={handleLogin}>
              {message && (
                <p
                  className={`text-center ${
                    typeof message === "string" && message.toLowerCase().includes("erreur")
                      ? "text-danger"
                      : "text-success"
                  }`}
                >
                  {message}
                </p>
              )}
              <div className="form-group">
  <input
    type="email"
    className="form-control"
    placeholder="Email"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    required
    style={{ color: 'white' }}
  />
</div>

<div className="form-group">
  <input
    type="password"
    className="form-control"
    placeholder="Mot de passe"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    required
    style={{ color: 'white' }}
  />
</div>
              <div className="form-group mt-3">
                <button type="submit" className="btn btn-block btn-primary btn-lg"  style={{ cursor: 'pointer' }} >
                  <small>Se connecter</small>
                </button>
              </div>
              <br />
              <div className="user_box_register user_box_link">
                <Button
                  variant="contained"
                  onClick={() => navigate(`/Inscription`)}
                  style={{
                    background: 'linear-gradient(to right, #fa9e1b, #8d4fff, #fa9e1b)',
                    color: 'white',
                    fontWeight: 'bold',
                    padding: '10px 20px',
                    borderRadius: '15px',
                  }}
                >
                  S'inscrire
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
